const API_ROUTE = process.env.VUE_APP_API_ROUTE

const GET_MENU_USER = API_ROUTE + '/get_menu_module_user'
// Massive SlOffer
const MASSIVE_CREATE_SL_OFFERS = API_ROUTE + '/massive_create_offer'
const MASSIVE_DELETE_SL_OFFERS = API_ROUTE + '/massive_delete_offer'

//APIs related to wholesale discounts:
const SL_WHOLESALE_DISCOUNT = API_ROUTE + '/sl_wholesale_discount'
const SL_WHOLESALE_DISCOUNT_FAMILY = API_ROUTE + '/sl_wholesale_discount_family'
const SL_WHOLESALE_DISCOUNT_SUBFAMILY = API_ROUTE + '/sl_wholesale_discount_subfamily'
// GModule
const GET_LOGIN_MODULE_DATA = API_ROUTE + '/get_login_module'
// Auth token
const GET_LOGIN_TOKEN = API_ROUTE + '/auth/get_login_token'
const LOGOUT_REQUEST = API_ROUTE + '/auth/logout'
const BLOCK_UNBLOCK_SL_CUSTOMER = API_ROUTE + '/sl_customer/block_unblock'
//const AUTH_UNIQUE_KEY = API_ROUTE + '/authorization'

export default {
    API_ROUTE,
    GET_MENU_USER,
    SL_WHOLESALE_DISCOUNT,
    SL_WHOLESALE_DISCOUNT_FAMILY,
    MASSIVE_CREATE_SL_OFFERS,
    MASSIVE_DELETE_SL_OFFERS,
    SL_WHOLESALE_DISCOUNT_SUBFAMILY,
    GET_LOGIN_MODULE_DATA,
    GET_LOGIN_TOKEN,
    LOGOUT_REQUEST,
    BLOCK_UNBLOCK_SL_CUSTOMER,
}
